import _ from "lodash";

export const convertSecondsToTime = ({ seconds }) => {
  switch (true) {
    case seconds < 60:
      return `${seconds} Sec.`;
    case seconds < 3600:
      return `${_.round(seconds / 60, 2)} Min.`;
    default:
      return `${_.round(seconds / 3600, 2)} Hr.`;
  }
};
